import axios from "../../axios";
import * as routes from "../../api-routes/Manager/Analytics";

export const getCustomersVisitsOverviewReq = (token, queryParams) => {
  return axios.get(
    `${process.env.REACT_APP_DASHBOARD_ENDPOINT}${routes.getCustomersVisitsOverview}`,
    {
      params: {
        ...queryParams,
      },
      headers: {
        token,
      },
    }
  );
};

export const getCustomersVisitsChartReq = (token, queryParams) => {
  return axios.get(
    `${process.env.REACT_APP_DASHBOARD_ENDPOINT}${routes.getCustomersVisitsChart}`,
    {
      params: {
        ...queryParams,
      },
      headers: {
        token,
      },
    }
  );
};
